import { create } from 'zustand';
import Repository from '@/types/repositoryType';
import RepositoryInfo from '@/types/repositoryInfoType';
import getRepositoryInfo from '@/apis/getRepositoryInfo';
import emptyRepositoryInfo from '@/types/emptyRepositoryInfo';
import headerObject from '@/types/headerObj';
import emptyHeaderObj from '@/types/emptyHeaderObj';
import useUserStore from './userState';
import useOrganizationStore from './orgState';
const headerObj: headerObject = emptyHeaderObj;
headerObj.Useruuid = useUserStore.getState().user?.UserUUID;
headerObj.Useremail = useUserStore.getState().user?.Email;
headerObj.Username = useUserStore.getState().user?.FirstName;
headerObj.Orgname = useOrganizationStore.getState().organization?.OrgName;
headerObj.Orguuid = useOrganizationStore.getState().organization?.OrgUUID;

interface RepositoryInfoState {
  repositroryInfo: RepositoryInfo;
  setRepositoryInfo: (repository: Repository) => Promise<boolean>;
}

const useRepositoryInfoStore = create<RepositoryInfoState>()((set, get) => ({
  repositroryInfo: emptyRepositoryInfo,

  setRepositoryInfo: async (repository: Repository) => {
    const repoDetails = await getRepositoryInfo(repository, headerObj);
    if (repoDetails !== emptyRepositoryInfo) {
      set({
        repositroryInfo: repoDetails,
      });
    }
    return true;
  },
}));

export default useRepositoryInfoStore;
